export default function convertHTMLToPlainText(html) {
  if (!html) return "";
  const tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = html;
  return tempDivElement.textContent || tempDivElement.innerText || "";
}